export interface AvatarPreset {
  id: string;
  url: string;
}

export const AVATAR_PRESETS: AvatarPreset[] = [
  {
    id: "wanjiku",
    url: "https://readdy.ai/api/search-image?query=Friendly%20warm%20portrait%20headshot%20of%20a%20smiling%20Kenyan%20woman%20in%20her%20thirties%20wearing%20a%20smart%20casual%20top%2C%20soft%20studio%20lighting%20with%20a%20warm%20neutral%20beige%20background%2C%20clean%20professional%20profile%20photography%2C%20high%20detail&width=400&height=400&seq=gari-avatar-wanjiku&orientation=squarish",
  },
  {
    id: "juma",
    url: "https://readdy.ai/api/search-image?query=Confident%20friendly%20portrait%20headshot%20of%20a%20smiling%20Kenyan%20man%20in%20his%20thirties%20wearing%20a%20casual%20button%20shirt%2C%20soft%20studio%20lighting%20with%20a%20warm%20neutral%20beige%20background%2C%20clean%20professional%20profile%20photography%2C%20high%20detail&width=400&height=400&seq=gari-avatar-juma&orientation=squarish",
  },
  {
    id: "amina",
    url: "https://readdy.ai/api/search-image?query=Warm%20approachable%20portrait%20headshot%20of%20a%20smiling%20Kenyan%20woman%20with%20short%20hair%20in%20a%20light%20blouse%2C%20soft%20studio%20lighting%20with%20a%20warm%20neutral%20beige%20background%2C%20clean%20professional%20profile%20photography%2C%20high%20detail&width=400&height=400&seq=gari-avatar-amina&orientation=squarish",
  },
  {
    id: "brian",
    url: "https://readdy.ai/api/search-image?query=Relaxed%20friendly%20portrait%20headshot%20of%20a%20smiling%20Kenyan%20man%20wearing%20a%20clean%20t-shirt%2C%20soft%20studio%20lighting%20with%20a%20warm%20neutral%20beige%20background%2C%20clean%20professional%20profile%20photography%2C%20high%20detail&width=400&height=400&seq=gari-avatar-brian&orientation=squarish",
  },
];